import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router'
import { GbAuctionHomeUrlService } from 'libs/gb-front/auction/util/src/lib/gb-auction-home-url-service/gb-auction-home-url.service'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CategoryViewGuard {
  homeUrlTree$ = this.gbAuctionHomeUrlService.homeUrlTree$

  constructor(
    private gbAuctionHomeUrlService: GbAuctionHomeUrlService,
    private gbNotificationService: GbNotificationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> | boolean {
    const catUuid: string | null | undefined = route.params['uuid']
    const categoryExists: boolean = !!catUuid && catUuid != 'null'

    if (categoryExists) {
      return true
    } else {
      this.gbNotificationService.error('CATEGORIES.NOT_FOUND_ERROR')
      return this.homeUrlTree$
    }
  }
}
